<template>
    <div>
        <div class="content">
            <div v-if="closeComment">
                <van-empty image="error" image-size="20vw" description="评论区已关闭" />
            </div>
            <van-list v-else
                v-model:loading="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="loadData"
                class="list"
            >
                <div class="item" v-for="item in list" :key="item.id">
                    <div class="avater">
                        <van-image
                            class="avatar-content"
                            round
                            fit="cover"
                            width="12vw"
                            height="12vw"
                            :src="item.userInfo.profile"
                        />
                    </div>

                    <div class="body">
                        <div class="content">
                            <span class="username">{{item.userInfo.username}}:</span>
                            {{item.content}}
                        </div>
                        <div class="date">{{item.createTime}}</div>
                    </div>

                    <!-- 先注释 -->
<!--                    <div class="star" @click="doStar(item)">-->
<!--                        <van-icon name="good-job-o" class="star-icon"/>-->
<!--                        {{item.support}}-->
<!--                    </div>-->
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import {doStarComment, getCommentList} from "@/api/CommonApi";
import {Toast} from "vant";

export default {
    name: 'CommentList',
    props: {
        itemId:{
            type:String,
            default:'',
        },
    },
    watch:{
        itemId(){
            this.init()
        }
    },
    data(){
        return{
            list:[],
            page:0,
            loading:false,
            finished:false,
            closeComment:false,//关闭评论区
        }
    },
    created() {
        this.init()
    },
    methods: {
        init(){
            this.closeComment = false
            this.finished = false
            this.loading = false
            this.page = 0
            this.list = []
        },
        doStar(item) {
            doStarComment(this.itemId,item.id).then(res => {
                if(res.result){
                    item.support += 1
                    return
                }
                Toast.fail('不能为此评论点赞')
            })
        },
        /**
         * 加载数据
         */
        loadData(){
            const itemId = this.itemId
            if(!itemId)return;
            if(this.finished)return;
            getCommentList(itemId,{pageNum:this.page + 1}).then(res => {
                const result = res.result
                if(!result){
                    this.finished = true
                    return
                }
                this.page = result.current
                this.finished = result.current >= result.pages
                this.list = [...this.list,...result.records]
            }).catch(() => {
                this.closeComment = true
                this.finished = true
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>
.item {
    display: flex;
    /** 不能设置00vw,很多地方用到了，排版有不同 */
    width: 100%;
    /*height: 12vw;*/
    /*margin-left: -10px;*/
    margin-bottom: 20px;
}

.avater {
    width: 19vw;
    text-align: right;
}

.body {
    padding-left: 10px;
    box-sizing: border-box;
    width: 63vw;
    position: relative;
}

.date {
    font-size: 12px;
    /*position: absolute;*/
    /*bottom: 5px;*/
    margin-top: 2px;
}

.star {
    width: 18vw;
    display: flex;
    line-height: 12vw;
}

.star-icon {
    line-height: 12vw;
    margin-right: 5px;
    font-size: 18px;
}
.content{
    white-space: break-spaces;
    word-wrap: break-word;
    word-break: break-all;
}
.username{
    font-weight: bold;
}
</style>
